/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Practice_Last_LearnedInputs */



/**
* | output |
* | --- |
* | "What did I learn from my last practice conversation?" |
*
* @param {Chat_Quick_Practice_Last_LearnedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_practice_last_learned = /** @type {((inputs?: Chat_Quick_Practice_Last_LearnedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Practice_Last_LearnedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wat leerde ik uit mijn vorige oefengesprek?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Qu'ai-je appris de ma dernière conversation d'entraînement ?")
	return /** @type {LocalizedString} */ ("What did I learn from my last practice conversation?")
});